// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"account":"600df283","administration":"8e8b96c8"}[chunkId] + ".chunk.js";
};